<template>
    <a-row class="mt10">
        <a-col :span = "2">
            <label class="foldText">{{rowIndex}}</label>
        </a-col>
        <a-col :span = "19">
            <a-select size="small" show-search v-model="field" @change="fieldChange">
                <a-select-option :key="index" :value="item" v-for="(item,index) in targetFieldItems">{{item}}</a-select-option>
            </a-select>
        </a-col>
    </a-row>
</template>
<script>
    export default {
        props:['index','targetFieldItems','infoFielditem'],
        data() {
            return {
                field:this.infoFielditem,
                rowIndex:this.index+1,
            }
        },
        methods:{
            fieldChange() {
                this.$emit('detailItemFieldChange',this.index, this.field)
            }
        }


    };
</script>